module.exports = __webpack_public_path__ + "static/img/one.4002672.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/channel/service/one.png
// module id = SfLV
// module chunks = 1